/*
  An opportunity a Strategy runs carries that strategy's workflow key (the AgentWorkflowDefinitions registry) on the
  row; a brand's own Plan carries none. The key is what routes an acceptance to Strategies billing (monthly arrears, the
  brand's Strategies payout terms and fee) instead of the brand's prepaid or fronted budget, so the two can run side by
  side at one brand.
*/

const isStrategyOpportunity = opportunity => !!opportunity?.strategyKey;

module.exports = {
  isStrategyOpportunity
};
